export default __webpack_public_path__ + "static/media/ambetter.7aa73ee0.jpeg";